import React, { useState } from 'react';
// logic
import ticketService from '../../ticket-service';
// components
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import {
  ModalContainer,
  CloseButtonContainer,
  ModalBody,
  ModalFooter,
  ModalFormContainer,
  ModalHeader,
  ModalHeaderInnerContainer,
  ModalHeaderMainText,
  ModalHeaderSecondaryText,
  ModalBoldText,
  ModalRegularText,
  CheckboxInputContainer,
  RadioInputsContainer,
} from './modalComponents';
import CheckBoxLabel from '../ticket-form/components/CheckBoxLabel';
import { PremiumInput } from '../../ui/inputs/customInput';
import { FormButton } from '../../ui/buttons/FormButton';

const CancelTicketModal = ({ ok, cancel, cancelTicketModalProps, t }) => {
  const { ticket = {} } = cancelTicketModalProps;

  const goBack = (e) => {
    e.preventDefault();
    cancel();
  };

  const formattedTicketId = ticketService.utils.getFormatedId(ticket.id);

  const availableReasons = {
    LATE: t('cancel_modal.late'),
    ALREADY_COVERED: t('cancel_modal.already_covered'),
    NOT_NEEDED: t('cancel_modal.not_needed'),
    OUT_OF_SCOPE: t('cancel_modal.out_of_scope'),
    OTHER: t('cancel_modal.other'),
  };

  const [reason, setReason] = useState(Object.keys(availableReasons)[0]);
  const [text, setText] = useState('');
  return (
    <ModalContainer>
      <ModalBody>
        <ModalHeader>
          <ModalHeaderInnerContainer>
            <ModalHeaderSecondaryText>
              {`${t('cancel_modal.subtitle')} ${formattedTicketId}`}
            </ModalHeaderSecondaryText>
            <ModalHeaderMainText>{t('cancel_modal.title')}</ModalHeaderMainText>
          </ModalHeaderInnerContainer>
        </ModalHeader>
        <ModalFormContainer>
          <ModalRegularText>{t('cancel_modal.select_reason')}</ModalRegularText>
          <RadioInputsContainer>
            {Object.keys(availableReasons).map((key) => (
              <CheckboxInputContainer onClick={() => setReason(key)}>
                {key === reason ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <circle cx="10" cy="10" r="10" fill="#2396DC" />
                    <circle cx="10" cy="10" r="4" fill="white" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <circle
                      cx="10"
                      cy="10"
                      r="9.5"
                      fill="white"
                      stroke="#E2E8EE"
                    />
                  </svg>
                )}

                <CheckBoxLabel>{availableReasons[key]}</CheckBoxLabel>
              </CheckboxInputContainer>
            ))}
          </RadioInputsContainer>
          <PremiumInput
            width={'100%'}
            type="text"
            label={t('cancel_modal.reasons_label')}
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
          <ModalBoldText>{t('cancel_modal.warning')}</ModalBoldText>
        </ModalFormContainer>
      </ModalBody>
      <ModalFooter>
        <FormButton variant="GHOST" onClick={goBack}>
          {t('cancel_modal.back')}
        </FormButton>
        <FormButton
          onClick={() =>
            ok({
              reason,
              text,
            })
          }
        >
          {t('cancel_modal.confirm')}
        </FormButton>
      </ModalFooter>
      <CloseButtonContainer onClick={goBack}>
        <CloseIcon />
      </CloseButtonContainer>
    </ModalContainer>
  );
};

export default CancelTicketModal;
// export default withTranslation('Emergencies')(CancelTicketModal);
